import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Rating } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'

const labels: { [index: string]: string } = {
  1: 'Rất không hài lòng',
  2: 'Không hài lòng',
  3: 'Bình thường',
  4: 'Hài lòng',
  5: 'Rất hài lòng',
}

export type IRatingDialogProps = DialogProps

export const RatingDialog = (props: IRatingDialogProps) => {
  const [value, setValue] = useState<number>()
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    setIsSubmitted(true)
    props.onClose?.(e, 'manual' as any)
  }

  return (
    <Dialog {...props}>
      <DialogTitle>Đánh giá trải nghiệm tự check-in</DialogTitle>
      <DialogContent
        style={{
          position: 'relative',
          overflow: 'hidden',
        }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Rating
            name="rating"
            style={{ fontSize: '4rem', marginBottom: '4px' }}
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue)
            }}
          />
        </Box>
        <Box
          minHeight="2.5rem"
          sx={{ color: (theme) => theme.palette.grey[600] }}
          bottom={0}
          left={0}
          width="100%"
          textAlign="center">
          {Boolean(value) && <Button onClick={handleSubmit}>{labels[value]}</Button>}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
